
const ALL_EVENT_NAMES = Object.freeze(['received', 'dropped', 'cleaned', 'deferred', 'sent', 'delivered', 'open', 'unique_open', 'click', 'unique_click', 'bounce', 'spam', 'unsubscribe_campaign', 'unsubscribe_global'])

// `received` was causing confusion
// by request not to show open and click - show unique open/click instead
const EXCLUDE_EVENT_NAMES = ['received', 'dropped', 'cleaned', 'deferred', 'open', 'click']

export const MAIL_EVENT_NAMES = Object.freeze(ALL_EVENT_NAMES.filter(evt => !EXCLUDE_EVENT_NAMES.includes(evt)))

export const MAIL_EVENT_DECORATORS = {
  received: { text: 'Received', color: 'primary--text', icon: 'mdi-send' },
  dropped: { text: 'Dropped', color: 'cyan--text', icon: 'mdi-minus-circle' },
  cleaned: { text: 'Cleaned', color: 'cyan--text', icon: 'mdi-minus-circle' },
  deferred: { text: 'Deferred', color: 'cyan--text', icon: 'mdi-bell-sleep' },
  sent: { text: 'Sent', color: 'primary--text', icon: 'mdi-send' },
  delivered: { text: 'Delivered', color: 'primary--text', icon: 'mdi-truck-delivery' },
  open: { text: 'Opens', color: 'green--text', icon: 'mdi-email-open' },
  unique_open: { text: 'Unique Opens', color: 'green--text text--darken-4', icon: 'mdi-email-open' },
  click: { text: 'Clicks', color: 'green--text', icon: 'mdi-cursor-default-click' },
  unique_click: { text: 'Unique Clicks', color: 'green--text text--darken-4', icon: 'mdi-cursor-default-click' },
  bounce: { text: 'Bounces', color: 'red--text', icon: 'mdi-alert' },
  spam: { text: 'Spam', color: 'red--text', icon: 'mdi-alert-octagon' },
  unsubscribe_campaign: { text: 'Unsubscribe Campaign', color: 'orange--text', icon: 'mdi-account-alert' },
  unsubscribe_global: { text: 'Unsubscribe Global', color: 'deep-orange--text', icon: 'mdi-account-alert' }
}

export const TOTP_MFA = 'SOFTWARE_TOKEN_MFA'
export const SMS_MFA = 'SMS_MFA'
